import Resource from '@/api/Resource';
import TestQuestion from './TestQuestion';
import User from '@/models/User';

class TestSession extends Resource {
  $name = 'sessions';

  $defaults() {
    return {
      id: null,
      user_id: 0,
      test_id: 0,
      begin_time: 0,
      complete: 0,
      success: 0,
      points: 0,
      testing_time: 0,
    };
  }

  $fill({ questions, user }) {
    if (questions) {
      this.questions = TestQuestion.collection(questions);
    }

    if (user) {
      this.user = new User(user);
    }
  }
}

export default TestSession;
